import tw from 'twin.macro';
import 'styled-components/macro';

import { ReactComponent as CheckIcon } from 'component-lib/atoms/icon-v2/CheckIcon.svg';
import { ReactComponent as MenuLeftIcon } from 'component-lib/atoms/icon-v2/MenuLeftIcon.svg';
import { ReactComponent as MenuRightIcon } from 'component-lib/atoms/icon-v2/MenuRightIcon.svg';
import { Menu } from 'component-lib/molecules/dropdown/menu/Menu';
import { MenuItem } from 'component-lib/molecules/dropdown/menu/MenuItem';
import { MenuItems } from 'component-lib/molecules/dropdown/menu/MenuItems';
import { MenuToggle } from 'component-lib/molecules/dropdown/menu/MenuToggle';

export interface PlacementPickerProps {
  onChange: (newValue: Placement) => void;
  value: Placement;
}

export type Placement = 'left' | 'right';

export function PlacementPicker({ onChange, value }: PlacementPickerProps) {
  const IconComponent = placementToIcon[value];

  return (
    <Menu>
      <MenuToggle
        css={[
          tw`bg-transparent! border-0 min-h-0 min-w-0 ring-white/10! rounded-xs text-white!`,
          { '&[aria-expanded=true]': tw`ring-0` },
        ]}
        infix={<IconComponent />}
      >
        {placementToLabel[value]}
      </MenuToggle>
      <MenuItems tw="bg-[#313d53] border-1 border-[#58647a] py-1 rounded-xs text-white w-20">
        <PlacementOption isSelected={value === 'right'} onSelect={onChange} value="right" />
        <PlacementOption isSelected={value === 'left'} onSelect={onChange} value="left" />
      </MenuItems>
    </Menu>
  );
}

interface PlacementOptionProps {
  isSelected: boolean;
  onSelect: (newValue: Placement) => void;
  value: Placement;
}

function PlacementOption({ isSelected, onSelect, value }: PlacementOptionProps) {
  const IconComponent = placementToIcon[value];

  return (
    <MenuItem
      onClick={() => onSelect(value)}
      prefix={<IconComponent />}
      postfix={isSelected && <CheckIcon />}
      tw="text-white! focus:bg-blue-light"
    >
      {placementToLabel[value]}
    </MenuItem>
  );
}

const placementToIcon = {
  left: MenuLeftIcon,
  right: MenuRightIcon,
};

const placementToLabel = {
  left: 'Pin left',
  right: 'Pin right',
};
